import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Loader } from '../components/Loading';
import DashboardLayout from '../components/DashboardLayout';
import { navigateTo } from '../actions/navigation';
import { doRemoveLocalRedirectSigninUrl, REDIRECT_SIGNIN_URL } from '../actions/invitations';


class SigninRedirect extends Component {

  componentWillMount() {
    const {
      redirect,
      redirectToHomePage,
      history,
      removeLocalStorageRedirectSigninUrl
    } = this.props;
    
    const url = localStorage.getItem(REDIRECT_SIGNIN_URL);

    if (!!url) {
      removeLocalStorageRedirectSigninUrl(url);
      redirect(history, url);
    } else {
      redirectToHomePage(history,'/');
    }

  }

  render() {
    
    return (
      <DashboardLayout>
        <Loader />
      </DashboardLayout>
    );
  }
}


const mapDispatchToProps = (dispatch, getState) => {
  return {
    redirect: (history, url) =>
      dispatch(navigateTo(history, url)),
    redirectToHomePage: (history) =>
      dispatch(navigateTo(history,'/')),
    removeLocalStorageRedirectSigninUrl: (url) => 
      dispatch(doRemoveLocalRedirectSigninUrl(url)),
  }
}

export default withRouter(
  connect(
    undefined,
    mapDispatchToProps
  )(SigninRedirect)
);


// WEBPACK FOOTER //
// ./src/containers/SigninRedirect.js